import { z } from "zod";
//#region src/signup/signup.ts
let TeamType = /* @__PURE__ */ function(TeamType) {
	TeamType["Personal"] = "personal";
	TeamType["Team"] = "team";
	return TeamType;
}({});
let TeamSize = /* @__PURE__ */ function(TeamSize) {
	TeamSize["One"] = "one";
	TeamSize["TwoToTen"] = "twoToTen";
	TeamSize["ElevenToFifty"] = "elevenToFifty";
	TeamSize["FiftyOnePlus"] = "fiftyOnePlus";
	return TeamSize;
}({});
let ProjectType = /* @__PURE__ */ function(ProjectType) {
	ProjectType["Analytics"] = "analytics";
	ProjectType["Defi"] = "defi";
	ProjectType["Gaming"] = "gaming";
	ProjectType["Wallet"] = "wallet";
	ProjectType["Security"] = "security";
	ProjectType["Social"] = "social";
	ProjectType["Marketplace"] = "marketplace";
	ProjectType["InfraAndTooling"] = "infraAndTooling";
	ProjectType["NFTs"] = "nfts";
	ProjectType["Identity"] = "identity";
	return ProjectType;
}({});
let ProjectSegment = /* @__PURE__ */ function(ProjectSegment) {
	ProjectSegment["New"] = "new";
	ProjectSegment["Existing"] = "existing";
	ProjectSegment["Explorer"] = "explorer";
	return ProjectSegment;
}({});
const SignupOptions = z.object({
	project_type: z.union([z.nativeEnum(ProjectType), z.string()]),
	project_segment: z.nativeEnum(ProjectSegment).nullable(),
	team_type: z.nativeEnum(TeamType).or(z.literal("")),
	team_size: z.nativeEnum(TeamSize).nullable(),
	chains: z.string(),
	other_chains: z.string().nullable(),
	enterprise_project_details: z.string().nullable()
});
let SetupStage = /* @__PURE__ */ function(SetupStage) {
	SetupStage[SetupStage["COMPLETE"] = 0] = "COMPLETE";
	SetupStage[SetupStage["CREATED"] = 1] = "CREATED";
	SetupStage[SetupStage["QUERYING"] = 2] = "QUERYING";
	SetupStage[SetupStage["CELEBRATING"] = 3] = "CELEBRATING";
	SetupStage[SetupStage["INVITING_TEAM"] = 4] = "INVITING_TEAM";
	SetupStage[SetupStage["BILLING"] = 5] = "BILLING";
	return SetupStage;
}({});
//#endregion
export { ProjectSegment, ProjectType, SetupStage, SignupOptions, TeamSize, TeamType };

//# sourceMappingURL=signup.js.map